import { name } from '@tv2-player/cast-player/src/CastPreset';
import UnifiedPlayer from '@tv2-player/unifiedplayer/src/core/UnifiedPlayer';
import { getPlayerConfiguration } from './player';

declare global {
  interface Window {
    ADBMobileConfig?: Record<string, any>;
  }
}

const options = getPlayerConfiguration().adobe;
Object.assign(options.mediaHeartbeat, {
  appVersion: UnifiedPlayer.version,
  playerName: name,
  ...options.mediaHeartbeat,
});
window.ADBMobileConfig = options;
